import { navigate as _navigate, NavigateOptions } from '@reach/router';
import { BASEPATH } from '../constants';
import { joinPath } from '../utils/path';
import routes from './routes';

const PERSISTENT_SEARCH_PARAMS = ['sid'];

function getTargetUrl(path: string): string {
  const currentUrl = new URL(window.location.href);
  const targetPath = joinPath(BASEPATH, path);
  const targetUrl = new URL(targetPath, currentUrl);

  currentUrl.searchParams.forEach((value, key) => {
    if (PERSISTENT_SEARCH_PARAMS.includes(key)) {
      targetUrl.searchParams.set(key, value);
    }
  });

  return targetUrl.toString();
}

function navigate(path: string, options?: NavigateOptions<any>) {
  const targetUrl = getTargetUrl(path);

  // TODO: handle route path pattern case
  const route = routes.find((_route) => _route.path === path);

  if (route) {
    // TODO: add ability to show loader over current page (via event emitter?)
    // TODO: preload component data before navigate?
    // NOTE: we don't need to know when `navigate` resolved, so ignore promise
    void route.component.preload().then(() => {
      _navigate(targetUrl, options);
    });

    return;
  }

  _navigate(targetUrl, options);
}

export { getTargetUrl };
export default navigate;
